import React from "react";
import { RealApp } from "./RealApp";

export const App: React.FC = () => {
  return <RealApp />;
};
